module.exports = __webpack_public_path__ + "static/img/banner1.10a5e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/banner1.jpg
// module id = 0Ooj
// module chunks = 1